import { render, staticRenderFns } from "./shopInfo.vue?vue&type=template&id=659cb1be"
import script from "./shopInfo.vue?vue&type=script&lang=js"
export * from "./shopInfo.vue?vue&type=script&lang=js"
import style0 from "./shopInfo.vue?vue&type=style&index=0&id=659cb1be&prod&lang=scss&scord=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports